module.exports = __webpack_public_path__ + "img/Stabilizer link.b68cb1b5.png";